import React, { useEffect, useState } from 'react';
import { useGroupUserHook } from '../../../hooks/group/useGroupUser';
import GroupItem from '../../../components/group-items/group-item';
import ModalCreateGroup from '../../group/components/modal-create-group';
import { Spin } from 'antd';
import { EmptyComponent } from '../../../components/empty/empty-component';
import { Search } from 'lucide-react';
import toast from 'react-hot-toast';
import { groupService } from '../../../services/group.service';
import { FetchPostParams, GroupDatas } from '../../../models';

const Group = () => {
  const [activeTab, setActiveTab] = useState('tab1');

  const [isOpenCreateGroup, setIsOpenCreateGroup] = useState(false);
  const handleOpenCreateGroup = () => {
    setIsOpenCreateGroup(true);
  };
  const handleCloseCreateGroup = () => {
    setIsOpenCreateGroup(false);
  };

  return (
    <div>
      <div className='class="flex flex-col gap-4"'>
        <div className="flex gap-3 text-palette-gray-500 overflow-auto w-fit">
          <button
            className={`font-medium border rounded-[100px] border-[#0071A6] px-4 text-base h-10 flex justify-center items-center cursor-pointer  ${
              activeTab === 'tab1'
                ? 'text-white bg-[#0071A6]'
                : 'text-[#0071A6]'
            }`}
            onClick={() => setActiveTab('tab1')}
          >
            Nhóm của tôi
          </button>
          <button
            className={`font-medium border rounded-[100px] border-[#0071A6] px-4 text-base h-10 flex justify-center items-center cursor-pointer  ${
              activeTab === 'tab2'
                ? 'text-white bg-[#0071A6]'
                : 'text-[#0071A6]'
            }`}
            onClick={() => setActiveTab('tab2')}
          >
            Đã tham gia
          </button>
          <button
            className={`font-medium border rounded-[100px] border-[#0071A6] px-4 text-base h-10 flex justify-center items-center cursor-pointer ${
              activeTab === 'tab3'
                ? 'text-white bg-[#0071A6]'
                : ' text-[#0071A6]'
            }`}
            onClick={() => setActiveTab('tab3')}
          >
            Đã yêu cầu
          </button>
        </div>
      </div>
      <div className="p-4">
        {activeTab === 'tab1' && (
          <Tab1Content
            isOpenCreateGroup={isOpenCreateGroup}
            handleOpenCreateGroup={handleOpenCreateGroup}
            handleCloseCreateGroup={handleCloseCreateGroup}
            title="Nhóm của tôi"
          />
        )}
        {activeTab === 'tab2' && (
          <Tab1Content
            isOpenCreateGroup={isOpenCreateGroup}
            handleOpenCreateGroup={handleOpenCreateGroup}
            handleCloseCreateGroup={handleCloseCreateGroup}
          />
        )}
        {activeTab === 'tab3' && <Tab3Content />}
      </div>
    </div>
  );
};

Group.propTypes = {};

export default Group;

interface ITab1Content {
  title?: string;
  handleOpenCreateGroup: () => void;
  isOpenCreateGroup: boolean;
  handleCloseCreateGroup: () => void;
}
const Tab1Content = ({
  title = 'Đã tham gia',
  isOpenCreateGroup,
  handleOpenCreateGroup,
  handleCloseCreateGroup,
}: ITab1Content) => {
  const [pageNumber, setPageNumber] = useState<number>(1);
  const { data: listGroup, loading } = useGroupUserHook({ pageNumber });
  const [searchQuery, setSearchQuery] = useState('');
  const filteredGroups = listGroup.filter((group) =>
    group.group.groupName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  return (
    <div className="flex flex-col gap-[10px]">
      <div className="flex justify-between items-center">
        <p className="text-[22px] leading-[28px] font-semibold text-slate-800 dark:text-slate-50">
          {title}
        </p>
        <button
          className="bg-[#DEE8FF] gap-[10px] backdrop-blur-sm text-[#0057FF] text-sm  h-[27px] px-2 flex items-center rounded-lg"
          onClick={handleOpenCreateGroup}
        >
          <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.53558 2.07227H7.46415C7.36891 2.07227 7.32129 2.11988 7.32129 2.21512V7.82227H2.00028C1.90504 7.82227 1.85742 7.86988 1.85742 7.96512V9.03655C1.85742 9.13179 1.90504 9.17941 2.00028 9.17941H7.32129V14.7866C7.32129 14.8818 7.36891 14.9294 7.46415 14.9294H8.53558C8.63081 14.9294 8.67843 14.8818 8.67843 14.7866V9.17941H14.0003C14.0955 9.17941 14.1431 9.13179 14.1431 9.03655V7.96512C14.1431 7.86988 14.0955 7.82227 14.0003 7.82227H8.67843V2.21512C8.67843 2.11988 8.63081 2.07227 8.53558 2.07227Z"
              fill="#0057FF"
            />
          </svg>
          <span>Tạo nhóm mới</span>
        </button>
        <ModalCreateGroup
          isOpen={isOpenCreateGroup}
          onClose={handleCloseCreateGroup}
        />
      </div>
      <div className=" w-full flex items-center">
        <div
          className=" relative rounded-[32px] z-20 bg-secondery w-full dark:!bg-white/5"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <input
            onChange={(e) => setSearchQuery(e.target.value)}
            type="text"
            placeholder="Tìm kiếm"
            className="w-full !pl-4 !font-normal !bg-transparent h-[29px] !text-sm outline-none text-[#657384]"
          />
          <Search
            size={20}
            className="absolute top-1/2 right-3 transform -translate-y-1/2 "
          />
        </div>
      </div>
      {loading ? (
        <div className="flex h-10 justify-center items-center">
          <Spin />
        </div>
      ) : filteredGroups.length > 0 ? (
        <div className=" grid grid-cols-2 gap-[6px]">
          {filteredGroups.map((group, index) => (
            <div key={index}>
              <GroupItem
                group={group.group}
                joinedTheGroup={group.joinedTheGroup}
                userStatus={group.userStatus}
              />
            </div>
          ))}
        </div>
      ) : (
        <EmptyComponent />
      )}
    </div>
  );
};

const Tab3Content = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const [isRefetch, setRefetch] = useState<boolean>(false);
  const [groupsRequest, setGroupsRequest] = useState<GroupDatas[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getGroups = async (payload: FetchPostParams) => {
      setLoading(true);
      try {
        const { data: dataRequest } =
          await groupService.getGroupRequestJoinOfUser(payload);
        setGroupsRequest(dataRequest.elements);
      } catch {
        //
      } finally {
        setLoading(false);
      }
    };
    const payload = {};
    getGroups(payload);
  }, [isRefetch]);
  const filteredGroups = groupsRequest.filter((group) =>
    group.group.groupName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const handleCancelJoinGroup = async (groupId: string) => {
    const res = await groupService.cancelJoinGroup(groupId);
    if (res.httpCode === 200) {
      toast.success('Đã hủy yêu cầu tham gia nhóm thành công');
      setRefetch(!isRefetch);
    }
  };
  return (
    <div className="flex flex-col gap-[10px]">
      <p className="text-[22px] leading-[28px] font-semibold text-slate-800 dark:text-slate-50">
        Đã yêu cầu
      </p>
      <div className=" w-full flex items-center">
        <div
          className=" relative rounded-[32px] z-20 bg-secondery w-full dark:!bg-white/5"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <input
            onChange={(e) => setSearchQuery(e.target.value)}
            type="text"
            placeholder="Tìm kiếm"
            className="w-full !pl-4 !font-normal !bg-transparent h-[29px] !text-sm outline-none text-[#657384]"
          />
          <Search
            size={20}
            className="absolute top-1/2 right-3 transform -translate-y-1/2 "
          />
        </div>
      </div>
      {loading ? (
        <div className="w-full h-20 flex justify-center items-center">
          <Spin />
        </div>
      ) : filteredGroups.length > 0 ? (
        filteredGroups.map((group, index) => (
          <div key={index}>
            <GroupItem
              group={group.group}
              joinedTheGroup={group.joinedTheGroup}
              userStatus={group.userStatus}
              cancelJoin={handleCancelJoinGroup}
            />
          </div>
        ))
      ) : (
        <EmptyComponent />
      )}
    </div>
  );
};
